module.exports = "/build/web/svg/icon-swipe--dark.145d429c7400cc4b27d34f9bb8958a73.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-swipe--dark.svg
// module id = 115
// module chunks = 11